module.exports = __webpack_public_path__ + "img/slotmachine_free_bg.0151328e.png";